import formBaseMixin from  '../../../components/form/form-base-mixin.js'
import {BILL_HOUSE_TYPE_MKD, BILL_HOUSE_TYPE_INDIVIDUAL, NORMATIVE_TYPE_INDIVIDUAL, NORMATIVE_TYPE_MKD, BANK_ACCOUNT_TYPE_LEGAL, STATUS_NOT_ACTIVE, GARBAGE_TYPE_MKD, BANK_ACCOUNT_TYPE_MKD} from "../../../config/config"
import {wasteGeneratorsOffline} from "../../../api/api-offline-endpoints";
import userFriendlyEr from "../../../utils/userFriendlyEr"
import {BILL_FORM} from "../types/types"
import url from '../../../utils/url'

export default {
  mixins: [formBaseMixin],
  data () {
    return {
      houseMoveRecalcOpened: false
    }
  },
  computed: {
    NORMATIVE_TYPE_INDIVIDUAL () {
      return NORMATIVE_TYPE_INDIVIDUAL
    },
    NORMATIVE_TYPE_MKD () {
      return NORMATIVE_TYPE_MKD
    },
    BANK_ACCOUNT_TYPE_LEGAL () {
      return BANK_ACCOUNT_TYPE_LEGAL
    },
    BANK_ACCOUNT_TYPE_MKD () {
      return BANK_ACCOUNT_TYPE_MKD
    },
    GARBAGE_TYPE_MKD () {
      return GARBAGE_TYPE_MKD
    },
    notActive () {
      return STATUS_NOT_ACTIVE
    },
    collection () {
      return this.$store.getters.readUrlEndpoint(
        this.getCollectionEndpoint()
      ) || {}
    }
  },
  beforeDestroy () {
    // reset bankBooks
    this.$store.commit('setEndpointData', {
      endpoint: this.getOfflineBankBooksDataUrl(),
      data: {
        data: []
      }
    })
  },
  created () {
    this.subsOnSave = this.$emitter.listen('form', (e) => this.onFormMutate(e))
  },
  destroyed () {
    this.subsOnSave.unsubscribe()
  },
  methods: {
    /**
     * @param fields {Object}
     * @param oldType {String}
     * @param newType {String}
     * @param resolver {Object}
     */
    updatedHouseMoveRecalc ({fields, oldType, newType, resolver}) {
      const typeRouteNameMap = {
        [BILL_HOUSE_TYPE_MKD]: 'wasteGenerators.apartmentBuildings.update',
        [BILL_HOUSE_TYPE_INDIVIDUAL]: 'wasteGenerators.individualAreas.update'
      }
      if (oldType !== newType && typeRouteNameMap[newType]) {
        const r = url.getRoute(this.$route)
        r.name = typeRouteNameMap[newType]
        r.params.id = fields.home_id
        delete r.query.prevRoute
        this.$router.push(r, () => {
          resolver.resolve()
          this.$e.successBox('Дом перемещен')
        })
      } else {
        resolver.resolve()
      }
    },
    openHouseMoveRecalc () {
      this.houseMoveRecalcOpened = true
    },
    closeHouseMoveRecalc () {
      this.houseMoveRecalcOpened = false
    },
    /**
     * @override
     */
    update () {
      if (this.item) {
        this.fields = Object.assign({}, this.item)
        // fix: https://redmine.etton.ru/issues/15053
        if (!this.fields.fact_address) {
          this.fields.fact_address = this.fields.name
        }
      }
    },
    onFormMutate (e) {
      if (e.name === BILL_FORM && (e.action == 'onSaveForm' || e.action == 'onRemove')) {
        const endpoint = this.getItemEndpoint(this.$route)
        if (endpoint !== null) {
          this.$store.dispatch('updateUrlEndpoint', {
            endpoint
          }).then(() => {
            if (this.item && this.item.hasOwnProperty('apartments_count')) {
              this.fields.apartments_count = this.item.apartments_count
            }
          })
        }
      }
    },
    getOfflineBankBooksDataUrl () {
      return wasteGeneratorsOffline.bankBooks()
    },
    afterSave: async function () {
      let errors = []

      // if offline mode
      if (!this.$route.params.id) {
        const items = this.$store.getters.readUrlEndpoint(
          this.getOfflineBankBooksDataUrl()
        )
        // debugger
        if (items && items.data) {
          for (let i = 0; i < items.data.length; i++) {
            try {
              await this.$store.dispatch('createModel', {
                url: this.getBankBookCreateUrl(),
                data: items.data[i]
              })
            } catch (e) {
              console.log(items.data[i])
              console.error(e)
              errors.push(
                userFriendlyEr.recognize(e)
              )
            }
          }
        }
      }
      if (errors.length > 0) {
        console.log(errors)
        return Promise.reject(errors.join('<br><br>'))
      }
      return Promise.resolve(1)
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    let promises = []
    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(route, fromRoute)}))
    }

    if (methods.getCollectionEndpoint) {
      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getCollectionEndpoint(),
        fromCache: true
      }))
    }

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  }
}
